export interface MockNotification {
  id: number;
  type: 'sms' | 'email' | 'push' | 'in_app';
  title: string;
  message: string;
  recipient: string;
  status: 'pending' | 'queued' | 'processing' | 'sent' | 'failed' | 'retrying';
  priority: 'low' | 'medium' | 'high' | 'urgent';
  scheduledAt?: string;
  sentAt?: string;
  createdAt: string;
  tripId?: string;
}

let mockNotifications: MockNotification[] = [
  {
    id: 1,
    type: 'in_app',
    title: 'یادآوری سفر',
    message: 'سفر شما به استانبول ۱۰ روز دیگر شروع می‌شود.',
    recipient: '09123456789',
    status: 'sent',
    priority: 'medium',
    sentAt: '2026-06-20T08:00:00.000Z',
    createdAt: '2026-06-20T08:00:00.000Z',
    tripId: 'mock-trip-1',
  },
  {
    id: 2,
    type: 'push',
    title: 'چک‌لیست ناقص',
    message: '۳ مورد از چک‌لیست سفر هنوز تکمیل نشده است.',
    recipient: '09123456789',
    status: 'pending',
    priority: 'low',
    scheduledAt: new Date(Date.now() + 2 * 60 * 60 * 1000).toISOString(),
    createdAt: new Date().toISOString(),
    tripId: 'mock-trip-1',
  },
];

export function getMockUserNotifications(_userId: string, limit = 50): Promise<MockNotification[]> {
  return Promise.resolve(mockNotifications.slice(0, limit));
}

export function addMockNotification(data: Omit<MockNotification, 'id' | 'createdAt'>): MockNotification {
  const notification: MockNotification = {
    ...data,
    id: Date.now(),
    createdAt: new Date().toISOString(),
  };
  mockNotifications = [notification, ...mockNotifications];
  return notification;
}

export function deleteMockNotification(id: number): void {
  mockNotifications = mockNotifications.filter((n) => n.id !== id);
}
